<div class="grid">
  <div class="cell-toolbar">
    @if (!receiptNo) {
      <cst-toolbar>
        <ctrl-btn-create
          i18n-title="@@InfoportalAPI_Receipts_Documents_FolderCreate"
          title="Create Folder"
          (click)="documentsTree.onFolderCreate(collectionNo)"
          [disabled]="!documentsTree.canFolderCreate(collectionNo)"
        ></ctrl-btn-create>
      </cst-toolbar>
    }
  </div>
  <div class="cell-list">
    <app-infoprtal-receipt-documents-tree
      #documentsTree
      [collectionNo]="collectionNo"
      [receiptNo]="receiptNo"
    ></app-infoprtal-receipt-documents-tree>
  </div>
</div>
